import { orchestrator } from 'satcheljs';
import { updateCachedColors } from '../actions/updateCachedColors';
import { setCalendarColorScheme } from 'owa-calendar-surface-calendars-store';
import { getCalendarFolderId } from 'owa-calendar-cache';

orchestrator(setCalendarColorScheme, actionMessage => {
    const { calendar, colorScheme } = actionMessage;
    const folderId = getCalendarFolderId(calendar);
    updateCachedColors(colorScheme, folderId);
});
